import { containsQuery, OdataFilters, ParamsFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/fuelCards";
const cardsQuery = { orderBy: ["id desc"] as [string] };

const allFuelCards = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...cardsQuery });
    return request(`${resource}/getFuelCardsList${query}`, { method: "GET" }, { countInHeaders: true });
};

const getAllListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...cardsQuery });
    return request(
        `${resource}/getListExcel?${query}&unlinkedCardsOnly=false`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Топливные карты.xlsx"));
};

const unlinkedFuelCards = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, {
        filter: { ...preparedFilter, carId: null, driverId: null },
        ...cardsQuery,
    });
    return request(`${resource}/getFuelCardsList${query}`, { method: "GET" }, { countInHeaders: true });
};

const getUnlinkedListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...cardsQuery });
    return request(
        `${resource}/getListExcel?${query}&simpleView=true`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Непривязанные топливные карты.xlsx"));
};

const driverFuelCards = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...cardsQuery });
    return request(`${resource}/getDriverFuelCardsList${query}`, { method: "GET" }, { countInHeaders: true });
};

const getDriverListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...cardsQuery });
    return request(
        `${resource}/getDriverFuelCardsListExcel?${query}&unlinkedCardsOnly=false`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Топливные карты по водителям.xlsx"));
};

const carFuelCards = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...cardsQuery });
    return request(`${resource}/getCarFuelCardsList${query}`, { method: "GET" }, { countInHeaders: true });
};

const getCarListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...cardsQuery });
    return request(
        `${resource}/getCarFuelCardsListExcel?${query}&unlinkedCardsOnly=false`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Топливные карты по машинам.xlsx"));
};

const getItem = (params: { id: string }) =>
    request(`${resource}/getForEdit?id=${params.id}`, { method: "GET" }).then((res) => {
        if (res) {
            res.carId = res.car?.id;
            res.driverId = res.driver?.id;
        }
        return res;
    });

const getCardNumberList = (params: { filters: ParamsFilters }) =>
    request(`${resource}/getCardNumberList${containsQuery(params)}`, { method: "GET" });
const applyCarFuelCards = (params: {}) => alertRequest(`${resource}/applyCarFuelCards`, body(params));
const applyDriverFuelCards = (params: {}) => alertRequest(`${resource}/applyDriverFuelCards`, body(params));
const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export {
    allFuelCards,
    apply,
    getItem,
    delItem,
    driverFuelCards,
    carFuelCards,
    getCardNumberList,
    applyCarFuelCards,
    applyDriverFuelCards,
    unlinkedFuelCards,
    getAllListExcel,
    getUnlinkedListExcel,
    getDriverListExcel,
    getCarListExcel,
};
